import PeopleContacts from './PeopleContacts';

export { type PeopleContactsProps } from './PeopleContacts';
export default PeopleContacts;
